export const EDIT_CODE = 'EDIT_CODE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_BACKGROUND = 'SET_BACKGROUND';
export const SET_CUSTOM_BACKGROUND = 'SET_CUSTOM_BACKGROUND';
